import { useSnackbar } from "notistack";
import React, { useState } from "react";

import { handleUserFinancialDonation } from "../../userDashboard/userControllers/donationController";


import load from "./assets/load.gif";

const Donation: React.FC = () => {
    const type = "Item";
    const [donation_type, setDonation_Type] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [note, setNote] = useState("");
    const [item_name, setItem_name] = useState("");
    const [quantity, setQuantity] = useState<number | "">("");
    const [status, setStatus] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(false);

    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        if (!name) newErrors.name = "Name is required";
        if (!donation_type) newErrors.donation_type = "Donation type is required";
        if (!phone) newErrors.phone = "Phone is required";
        if (!email) newErrors.email = "Email is required";
        if (!status) newErrors.status = "Status is required";
        if (!quantity || (typeof quantity === 'number' && quantity <= 0))
            newErrors.quantity = "Valid quantity is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSuccess = () => {
        setLoading(false);
        enqueueSnackbar("Donation Added", { variant: "success" });
    };

    const onError = () => {
        setLoading(false);
        enqueueSnackbar("Failed to add donation", { variant: "error" });
    };

    const handleSubmit = () => {
        if (validateFields()) {
            setLoading(true);
            const userData = {
                name,
                email,
                type,
                note,
                donation_type,
                phone,
                quantity,
                item_name,
                status,
            };

            handleUserFinancialDonation(userData, onSuccess, onError);
        } else {
            enqueueSnackbar("Please fix the errors in the form", {
                variant: "error",
            });
        }
    };

    return (
        <div className=" space-y-4 md:space-y-6 w-full">
            <div className=" grid  grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full">
                <label
                    htmlFor="full-name"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Full Name
                    <input
                        id="full-name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                        placeholder="Enter Full Name"
                    />
                    {errors.name && (
                        <span className="text-red-500 text-xs font-Manrope mt-2">
                            {errors.name}
                        </span>
                    )}
                </label>
                <label
                    htmlFor="email"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Email Address
                    <input
                        id="email"
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                        placeholder="Enter Email Address"
                    />
                    {errors.email && (
                        <span className="text-red-500 text-xs font-Manrope mt-2">
                            {errors.email}
                        </span>
                    )}
                </label>
            </div>
            <div className=" grid  grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full">
                <label
                    htmlFor="phone"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Phone Number
                    <input
                        id="phone"
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                        placeholder="Enter Phone Number"
                    />
                    {errors.phone && (
                        <span className="text-red-500 text-xs font-Manrope mt-2">
                            {errors.phone}
                        </span>
                    )}
                </label>
                <label
                    htmlFor="donation-type"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Donation Type
                    <span
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                    >
                        <select
                            id="donation-type"
                            value={donation_type}
                            onChange={(e) => setDonation_Type(e.target.value)}
                            className=" w-full bg-white outline-none"
                        >
                            <option value="">Select Type </option>
                            <option value="recurring">Recurring Donation</option>
                            <option value="one_time">One-time Donation</option>
                        </select>
                    </span>
                    {errors.donation_type && (
                        <span className="text-red-500 text-xs font-Manrope mt-2">
                            {errors.donation_type}
                        </span>
                    )}
                </label>
            </div>
            <label
                htmlFor="item-name"
                className=" w-full flex flex-col font-Manrope text-sm font-semibold"
            >
                Item Name
                <input
                    id="item-name"
                    type="text"
                    value={item_name}
                    onChange={(e) => setItem_name(e.target.value)}
                    className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                    placeholder="Enter Item name"
                />
                {errors.item_name && (
                    <span className="text-red-500 text-xs font-Manrope mt-2">
                        {errors.item_name}
                    </span>
                )}
            </label>
            <div className=" grid  grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full">
                <label
                    htmlFor="quantity"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Quantity
                    <input
                        id="quantity"
                        type="number"
                        min="0"
                        value={quantity}
                        onChange={(e) => {
                            const value = parseInt(e.target.value);
                            if (!isNaN(value) && value >= 0) {
                                setQuantity(value);
                            } else if (e.target.value === "") {
                                setQuantity("");
                            }
                        }}
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                        placeholder="Enter Quantity"
                    />
                </label>
                <label
                    htmlFor="status"
                    className=" w-full flex flex-col font-Manrope text-sm font-semibold"
                >
                    Status
                    <span
                        className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                    >
                        <select
                            id="status"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className=" w-full bg-white outline-none"
                        >
                            <option value="">Choose status</option>
                            <option value="Used">Used</option>
                            <option value="New">New</option>
                        </select>
                    </span>
                    {errors.status && (
                        <span className="text-red-500 text-xs font-Manrope mt-2">
                            {errors.status}
                        </span>
                    )}
                </label>
            </div>

            <label
                htmlFor="note"
                className=" w-full flex flex-col font-Manrope text-sm font-semibold"
            >
                Note
                <input
                    id="note"
                    type="text"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    className=" mt-2 border bg-white border-[#DAE0E6] rounded-md py-3 px-4 font-Manrope font-normal text-[15px] placeholder:text-[#919BA7]"
                    placeholder="Anything you'd like to tell us?"
                />
            </label>
            <div className=" w-full">
                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className=" bg-[#78C257] px-6 py-3 rounded-[6px] text-[#F5F8FE] font-Manrope font-semibold text-base flex justify-center items-center"
                >
                    {loading ? (
                        <img src={load} className=" w-5" alt="Loading" />
                    ) : (
                        "Make Donation"
                    )}
                </button>
            </div>
        </div>
    );
};

export default Donation;
